import React from "react";

/*eslint-disable*/

interface PropertiesLayouts {
  layoutsArray: any;
}

interface Props {
  showDetailedLayouts: boolean;
  angle: number;
  scriptData: any;
  handleShowTooltip: any;
  colorsData: any;
  propertiesData: any;
  propertyFilterArray: any;
  avalabilityAttributesToShow: any;
  hasDispo: boolean;
}

interface State {
  showDetailedLayouts: boolean;
  rgbaColor: any;
  hslColor: any;
  filteredData: any;
  isFilterActive: boolean;
  currentSelectedProperty: string;
  isMouseDown: boolean;
  isMouseMoving: boolean;
}

class DetailedLayoutsMobile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showDetailedLayouts: false,
      rgbaColor: "",
      hslColor: "",
      filteredData: [],
      isFilterActive: false,
      currentSelectedProperty: "",
      isMouseDown: false,
      isMouseMoving: false,
    };
  }

  componentDidMount(): void {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
      this.props.colorsData.main_buttons
    );
    this.setState(
      {
        rgbaColor: result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
            }
          : "",
      },
      () => {
        var r, g, b;
        r = this.state.rgbaColor.r / 255;
        g = this.state.rgbaColor.g / 255;
        b = this.state.rgbaColor.b / 255;

        const l = Math.max(r, g, b);
        const s = l - Math.min(r, g, b);
        const h = s
          ? l === r
            ? (g - b) / s
            : l === g
            ? 2 + (b - r) / s
            : 4 + (r - g) / s
          : 0;

        var resultHSL = {
          h: 60 * h < 0 ? 60 * h + 360 : 60 * h,
          s:
            100 *
            (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
          l: (100 * (2 * l - s)) / 2,
        };

        this.setState({
          hslColor: resultHSL,
        });
      }
    );

    this.setState(
      {
        showDetailedLayouts: true,
      },
      () => {
        this.updateLayoutsInfo();
      }
    );

    document.addEventListener("mousedown", () => {
      this.setState({
        isMouseDown: true,
      });
    });
    document.addEventListener("mouseup", () => {
      this.setState({
        isMouseDown: false,
        isMouseMoving: false,
      });
    });
    document.addEventListener("mouseleave", () => {
      this.setState({
        isMouseDown: false,
        isMouseMoving: false,
      });
    });
    document.addEventListener("mousemove", () => {
      if (this.state.isMouseDown) {
        this.setState({
          isMouseMoving: true,
        });
      }
    });
  }

  updateLayoutsInfo = () => {
    if (
      this.props.propertiesData &&
      this.props.propertiesData.property &&
      this.props.scriptData
    ) {
      this.props.propertiesData.property.map((property: any, index: number) =>
        this.props.scriptData.detail_coord_file.map(
          (frame: any, indexFrame: number) =>
            frame.datails.map(
              (frameProperty: any, indexFrameProperty: number) => {
                var tempValuesArray: any = [];
                if (frameProperty.id === property.id) {
                  property.values.map((value: any, indexValue: number) =>{
                    tempValuesArray[value.attribute] = value.value
                    tempValuesArray[property.id] = property.property
                  });
                  frameProperty.values = tempValuesArray;
                  frameProperty.availability = property.availability;
                }

                return 0;
              }
            )
        )
      );
    }
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      this.props.scriptData !== prevProps.scriptData &&
      this.props.scriptData.detail_coord_file
    ) {
      this.setState(
        {
          showDetailedLayouts: true,
        },
        () => {
          this.updateLayoutsInfo();
        }
      );
    }
    if (
      prevProps.showDetailedLayouts !== this.props.showDetailedLayouts &&
      this.props.showDetailedLayouts
    ) {
      this.createLayouts();
    }
    if (
      prevProps.angle !== this.props.angle &&
      this.props.showDetailedLayouts
    ) {
      this.createLayouts();
    }
    if (
      prevProps.propertyFilterArray &&
      this.props.propertyFilterArray &&
      this.props.propertyFilterArray.length > 0
    ) {
      this.createLayouts();
    }
    if (
      prevProps.avalabilityAttributesToShow !==
      this.props.avalabilityAttributesToShow
    ) {
      this.createLayouts();
    }
  }

  clearLayoutFilter = () => {
    this.setState({
      currentSelectedProperty: "",
    });
  };

  createLayouts = () => {
    if (
      this.props.scriptData.detail_coord_file &&
      this.props.scriptData.detail_coord_file[this.props.angle]
    ) {
      if (
        this.props.scriptData.detail_coord_file[this.props.angle].datails
          .length > 0
      ) {
        var bubblesToShow: any =
          this.props.scriptData.detail_coord_file[this.props.angle].datails;

        var tempArrayDropdown: any = [];
        var tempAvailabilityArray: any = [];

        Object.keys(this.props.propertyFilterArray).map((key: any, index: number) => {
          var tempArray: any = []
          bubblesToShow.map((property: any) => {
            if(this.props.propertyFilterArray[key].length > 0){        
              if(property.hasOwnProperty('values') && this.props.propertyFilterArray[key].includes(property.values[key])){
                tempArray.push(property)
              }
            }
            else {
              tempArray.push(property)
            }
          })

          bubblesToShow = tempArray
        })


        bubblesToShow.map((property: any, index: number) => {
          if (
            this.props.avalabilityAttributesToShow.includes(
              property.availability
            )
          ) {
            tempAvailabilityArray.push(property);
          }
        });

        bubblesToShow = tempAvailabilityArray;

        return bubblesToShow.map((property: any, index: number) => (
          property.verts.length === 4 ?
          <polygon
            key={index + "layouts"}
            points={
              property.verts[0][0] +
              "," +
              property.verts[0][1] +
              " " +
              property.verts[1][0] +
              "," +
              property.verts[1][1] +
              " " +
              property.verts[3][0] +
              "," +
              property.verts[3][1] +
              " " +
              property.verts[2][0] +
              "," +
              property.verts[2][1] +
              " "
            }
            style={{
              cursor: "pointer",
              fill:
                property.availability === "DISPONIBLE" && this.props.hasDispo
                  ? `hsla(${120}, ${100}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 70
                        : 50
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.65
                        : 0.3
                    })`
                  : property.availability === "VENDIDO" && this.props.hasDispo
                  ? `hsla(${0}, ${100}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 70
                        : 50
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.65
                        : 0.3
                    })`
                  : property.availability === "NO DISPONIBLE" &&
                    this.props.hasDispo
                  ? `hsla(${0}, ${0}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 20
                        : 0
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.65
                        : 0.3
                    })`
                  : `hsla(${this.state.hslColor.h}, ${
                      this.state.hslColor.s
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? this.state.hslColor.l + 20
                        : this.state.hslColor.l
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.65
                        : 0.3
                    })`,
              stroke:
                property.availability === "DISPONIBLE" && this.props.hasDispo
                  ? `hsla(${120}, ${100}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 70
                        : 50
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.8
                        : 0.65
                    })`
                  : property.availability === "VENDIDO" && this.props.hasDispo
                  ? `hsla(${0}, ${100}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 70
                        : 50
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.8
                        : 0.65
                    })`
                  : property.availability === "NO DISPONIBLE" &&
                    this.props.hasDispo
                  ? `hsla(${0}, ${0}%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 20
                        : 0
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.8
                        : 0.65
                    })`
                  : `hsla(${this.state.hslColor.h}, ${
                      this.state.hslColor.s
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? this.state.hslColor.l + 20
                        : this.state.hslColor.l
                    }%, ${
                      this.state.currentSelectedProperty === property.id
                        ? 0.8
                        : 0.65
                    })`,
              strokeWidth: 2,
              animation:
                this.state.currentSelectedProperty === property.id
                  ? "fadeAnimation 2s linear infinite"
                  : "",
            }}
            onClick={(e) => {
              this.setState({
                currentSelectedProperty: property.id,
              });
              this.props.handleShowTooltip(property.id, e);
            }}
            data-type={"INMUEBLE"}
            data-value={property.id}
          ></polygon>:
          <text x={property.verts[0]} y={property.verts[1]} text-anchor="middle" alignment-baseline="middle" font-size="0.8rem" fill="white"
          onClick={(e) => {
            this.setState({
              currentSelectedProperty: property.id,
            });
            var isRigth = e.clientX > window.screen.width / 2
            this.props.handleShowTooltip(property.id, e);
            }}
          >
          {property.values[property.id]}
        </text>
        ));
      }
    }
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.showDetailedLayouts
            ? "layouts-property fade-in"
            : "layouts-property fade-out"
        }
      >
        {this.state.showDetailedLayouts ? (
          <svg
            width={"100%"}
            height={"100%"}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 1400 2000"
            style={{
              overflow: "hidden",
              pointerEvents: "none",
              position: "absolute",
            }}
          >
            <g
              style={{
                pointerEvents:
                  this.state.isMouseDown && this.state.isMouseMoving
                    ? "none"
                    : "visibleFill",
              }}
            >
              {this.createLayouts()}
            </g>
          </svg>
        ) : null}
      </div>
    );
  }
}

export default DetailedLayoutsMobile;
